import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import InitiateReset from "./initiate.js";
import LocaleStrings from "Languages";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  gotoLoginScreen = () => {
    this.props.history.push("/login");
  };

  render() {
    return (
      <div style={{ background: "#3f4458" }}>
        <div
          className="pull-right header-right"
          style={{ position: "absolute", right: 50, top: 20 }}
        >
          <Button
            type="button"
            style={{ width: 95 }}
            className="button-theme btn-primary"
            onClick={this.gotoLoginScreen}
          >
            {LocaleStrings.login}
          </Button>
        </div>
        <div className="text-center template-container">
          <InitiateReset {...this.props} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
  };
}

export default connect(mapStateToProps, null)(ResetPassword);
